<!--
	name: LeftMenu   Version: V3.0   by: coon    publish: 2022/07/31;
	include:

	功能：该组件用于实现左侧二级菜单的显示与响应
	可提供如下功能, 支持的形态及功能有:
		1.  支持一级菜单显示图标+文字+展开/收起箭头, 重点:一级菜单不支持响应事件
		2.  支持二级菜单小圆点前缀+文字+选中状态
		3.  支持二级菜单指定响应事件, 响应事件参数为当前菜单数据
		4.  支持设置菜单的隐藏状态, 隐藏状态下, 当鼠标移动到菜单标题栏时会显示title
		5.  菜单文本超出长度, 自动显示 ...
	组件调用参数:
		menuAct:      用于方便内部记录及过渡处理当前选中项, 调用者不需要使用该参数
		titleShow:    指定组件是否显示title
		menuData:     菜单项数据
			[{                  一级菜单
				cont:"",        菜单显示文本
				h:40,           菜单项的高度
				icon:"",        菜单前置图标
				expand:0,       菜单默认是否展开, 0-不展开, 1-展开
				subMenus:[{         二级菜单
					cont:"",        菜单显示文本
					v:"",           菜单项对应的值
					h:30,           菜单项的高度
					clk:null,       菜单项的响应事件, 参数为当前菜单项数据
				}]
			}]
	外部调用方法:
		无
-->

<template>
	<div style="width:100%;" :key="MenuKey">
		<div id="idMenuItem" ref="idMenuItem" v-if="menuData.length" v-for="(curMenu, index) in menuData" :index="index" class="MenuItemPanel">
			<div style="width:100%; height:1px;"></div>
			<div id="idMenuCaptPanel" ref="idMenuCaptPanel" :class="getMenuCaptClass(curMenu)" :style="{'height':curMenu.h+'px'}" @click="onMenuClick(curMenu, index)">
				<div style="width:1px; height:100%; background:#ffffff;"></div>
				<div style="height:100%; width:12px; border:0px solid blue;"></div>
				<div id="idMenuIcon" ref="idMenuIcon" class="MenuIcon" :style="{'background':getIconImg(curMenu),'background-size':'100% 100%'}"></div>
				<div id="idMenuCont" ref="idMenuCont" class="MenuCont">{{ curMenu.cont }}</div>
				<div id="idRightArrow" ref="idRightArrow" :class="getArrowClass(curMenu)"></div>
				<div style="height:100%; width:4px; border:0px solid blue;"></div>
				<div style="width:1px; height:100%; background:#ffffff;"></div>
			</div>
			<div id="idMenuBodyPanel" ref="idMenuBodyPanel" class="MenuBodyPanel" :style="{'display':isExpand(curMenu)}">
				<LeftMenu v-if="curMenu.subMenus" :menuData="curMenu.subMenus" :menuAct="menuAct" :titleShow="titleShow" style="width:100%; height:100%; flex:1; overflow-x:hidden; overflow-y:auto;"></LeftMenu>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'LeftMenu',
	props:['menuData', 'menuAct', 'titleShow'],
	data () {
		return {
			MenuKey: 0,
			keyArrow: 1,              //菜单右侧箭头刷新控制key
		}
	},
	watch:{
		titleShow( newV, oldV){
			let capts=this.$refs["idMenuCaptPanel"];
			if( !capts || !capts.length ) return;
			if( newV == true )
			{
				for( let i=0; i<capts.length; i++ )
				{
					capts[i].setAttribute("title", "");
				}
			}
			else
			{
				for( let i=0; i<capts.length; i++ )
				{
					capts[i].setAttribute("title", this.menuData[i].cont);
				}
			}
		},
	},
	mounted: function(){

	},
	computed:{

	},
	methods:{
		/* 判断是否有字节点 */
		hasChild: function( curMenu ){
			if( curMenu.subMenus && (0<curMenu.subMenus.length) ) return true; else return false;
		},
		/* 判断菜单是否展开 */
		isExpand: function( menu ){
			if( menu.expand == 0 ) return "none"; else return "block";
		},
		/* 取得菜单对应的样式类 */
		getMenuCaptClass: function( menu ){
			if( menu.subMenus && (0<menu.subMenus.length) ) return "MenuCaptPanel"; else return "MenuCaptPanel2";
		},
		/* 取得菜单右侧箭头对应的样式类 */
		getArrowClass: function( menu ){
			if( menu.subMenus && (0<menu.subMenus.length) ) return "RightArrow"; else return "RightArrowN";
		},
		/* 取得菜单前置图标 */
		getIconImg: function( menu ){
			if( menu.icon ) return 'url('+menu.icon+')'; else return "url(../../static/images/menu_icon.png)";
		},
		/* 菜单点击事件 */
		onMenuClick: function( menu, idx ){
			if( menu.subMenus && (0<menu.subMenus.length) )
			{
				let arrows=this.$refs["idRightArrow"];
				if( menu.expand == 0 )
				{
					menu.expand = 1;
					arrows[idx].setAttribute("class", "RightArrowA");
				}
				else
				{
					menu.expand = 0;
					arrows[idx].setAttribute("class", "RightArrow");
				}
				this.MenuKey++;
			}
			else
			{
				if( this.menuAct.capt )
				{
					this.menuAct.capt.style["background"] = "#ffffff";
				}

				this.menuAct.capt = this.$refs["idMenuCaptPanel"][idx];
				this.menuAct.capt.style["background"] = "var(--hoverClr)";
			}
			if( menu.clk ) menu.clk( menu );
		},
	}
}

</script>

<style scoped>

.MenuItemPanel{width:100%; border:0px solid red; }
.MenuItemPanel .MenuCaptPanel{width:100%; background:var(--clrBG1); color:#ffffff; display:flex; align-items:center; cursor:pointer; }
.MenuItemPanel .MenuCaptPanel:hover{background: #2fafff; }
.MenuItemPanel .MenuCaptPanel .MenuIcon{height:20px; width:20px; border:0px solid blue; flex-shrink:0; }
.MenuItemPanel .MenuCaptPanel .MenuCont{flex:1; padding-left:6px; border:0px solid red; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; }
.MenuItemPanel .MenuCaptPanel .RightArrow{ height:11px; width:11px; border:0px solid blue; background:url(../../static/images/menu_right_arrow.png);}
.MenuItemPanel .MenuCaptPanel .RightArrowA{height:11px; width:11px; border:0px solid blue; background:url(../../static/images/menu_right_arrow_a.png);}
.MenuItemPanel .MenuCaptPanel .RightArrowN{height:11px; width:11px; border:0px solid blue;}
.MenuItemPanel .MenuCaptPanel2{width:100%; background:#ffffff; display:flex; align-items:center; cursor:pointer; }
.MenuItemPanel .MenuCaptPanel2:hover{background: var(--hoverClr); }
.MenuItemPanel .MenuCaptPanel2 .MenuIcon{height:20px; width:20px; border:0px solid blue; flex-shrink:0; }
.MenuItemPanel .MenuCaptPanel2 .MenuCont{flex:1; padding-left:6px; border:0px solid red; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; }
.MenuItemPanel .MenuCaptPanel2 .RightArrow{ height:11px; width:11px; border:0px solid blue; background:url(../../static/images/menu_right_arrow.png);}
.MenuItemPanel .MenuCaptPanel2 .RightArrowA{height:11px; width:11px; border:0px solid blue; background:url(../../static/images/menu_right_arrow_a.png);}
.MenuItemPanel .MenuCaptPanel2 .RightArrowN{height:11px; width:11px; border:0px solid blue;}
.MenuItemPanel .MenuBodyPanel{width:100%; border:0px solid blue;}

</style>



// WEBPACK FOOTER //
// leftmenu.vue?19e3903a